module.exports = __webpack_public_path__ + "mu.aa4c05837f3312bdb565.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/mu.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/mu.svg
// module chunks = styles